// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"1af8e3f3","277":"95b51c77"}[chunkId] + ".chunk.js";
};